<template>
    <div class="container products">
        <nav class="level" style="margin-bottom: 48px">
            <div class="level-left">
                <div class="level-item">
                    <b-input v-model="filter" placeholder="Søk" type="search" icon="search" style="margin-left:auto"></b-input>
                </div>
                
            </div>
            <div class="level-right">
                <div class="level-item">
                    <b-dropdown>
                        <button class="button" slot="trigger">
                            <span>Mangler mapping</span>
                            <b-tag rounded type="is-warning" style="margin-left: 8px">{{ totalMissingCount }}</b-tag>
                            <b-icon pack="fa" icon="angle-down"></b-icon>
                        </button>

                        <b-dropdown-item has-link>
                            <router-link to="/missingmapping/r0901" class="navbar-item">
                                <span>R0901 Gavekortrapporter</span>
                                <b-tag rounded type="is-warning">{{ countR0901 }}</b-tag>
                            </router-link>
                        </b-dropdown-item>
                        <b-dropdown-item has-link>
                            <router-link to="/missingmapping/cp" class="navbar-item">
                                <span>CP106/CP303/CP309</span>
                                <b-tag rounded type="is-warning">{{ countCp303 }}</b-tag>
                            </router-link>
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
                <p class="level-item">
                    <a class="button is-primary" @click="newBranch()">
                        <b-icon pack="fa" icon="plus"></b-icon>
                        <span>Nytt firma</span>
                    </a>
                </p>
            </div>
        </nav>
        
        <div class="columns" v-for="(branch, index) in filtered" :key="index">
           
            <div class="column">
                <nav class="level">
                    <div class="level-left">
                        <div class="level-item has-text-centered" style="margin-left: 32px">
                            <div>
                                <p class="heading">BransjeID</p>
                                <p class="title is-4">{{ branch.id }}</p>
                            </div>
                        </div>
                        <div class="level-item has-text-centered">
                            <div>
                                <p class="heading">Firma</p>
                                <p class="title is-4">{{ branch.name }}</p>
                            </div>
                        </div>                        
                    </div>
                    <div class="level-right">
                    <div class="level-item has-text-centered">
                        <div>
                            <a class="button is-danger" @click="confirmDeleteBranch(branch)">
                                <b-icon pack="fa" icon="trash"></b-icon>
                                <span>Slett {{ branch.name }}</span>
                            </a>
                        </div>
                    </div>
                    </div>
                </nav>
                <div class="box">
                    <b-tabs position="is-centered" class="block">
                        <b-tab-item icon="money-bill" label="R0901 - Produkter">
                            <r0901-mapper :branch="branch" :report-types='reportTypes'></r0901-mapper>
                        </b-tab-item>
                        <b-tab-item icon="gift" label="CP-rapporter - Gavekortprodukter, Breakage, Saldo">
                            <cp303-mapper :branch="branch"></cp303-mapper>
                        </b-tab-item>

                    </b-tabs>
                </div>
                <div class="is-divider" style="margin-top: 48px; margin-bottom: 16px"></div>
            </div>
            
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Cp303Mapper from '@/components/Cp303Mapper.vue'
import R0901Mapper from '@/components/R0901Mapper.vue'
import BranchModal from '@/components/products/BranchModal.vue'

export default {
    data () {
        return {
            filter: ''
        }
    },
    components: {
        Cp303Mapper, R0901Mapper
    },
    computed: {
        ...mapGetters('products', ['mappings']),
        ...mapGetters('reporttypes', ['reportTypes']),
        ...mapGetters('missingmappings', ['countCp303', 'countR0901', 'totalMissingCount']),
        filtered: function() {
            const filtered = this.mappings.filter(mapping => Object.keys(mapping).some(k => mapping[k].toString().toLowerCase().includes(this.filter.toLowerCase())))
            return filtered;
        }

    },
    methods: {
        ...mapActions('products', ['getCompanyMappings', 'deleteBranch']),
        ...mapActions('reporttypes', ['getReportTypes']),
        ...mapActions('missingmappings', ['getMissingMappings']),
        ...mapActions('reportsets', ['getReportsets']),
        newBranch () {
            const branch = {
                id: '',
                name: ''
            }
            this.launchModal(branch)
        },
        editBranch (branch) {
            this.launchModal(branch)
        },
        launchModal (branch) {
            this.$buefy.modal.open({
                parent: this,
                component: BranchModal,
                hasModalCard: true,
                props: {branch: branch}, 
            }) 
        },
        confirmDeleteBranch (branch) {
            this.$buefy.dialog.confirm({
                title: 'Slette firma',
                message: `Er du sikker på at du ønsker å <b>slette ${branch.name}</b>? Denne aksjonen kan ikke angres.`,
                confirmText: 'Slett',
                cancelText: 'Avbryt',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => this.deleteConfirmAction(branch)
            })
        },
        async deleteConfirmAction (branch) {
            try {
                await this.deleteBranch(branch)
                this.$buefy.toast.open({
                    message: 'Firmaet ble slettet',
                    type: 'is-success',
                    position: 'is-bottom'
                })
            }
            catch (error) {
                this.$buefy.toast.open({
                    message: 'En feil oppstod under sletting av firma',
                    type: 'is-danger',
                    position: 'is-bottom'
                })
            }
        }
    },
    created () {
        this.getReportTypes()
        this.getCompanyMappings()        
        this.getMissingMappings()
        this.getReportsets()
    }
}
</script>

<style lang="scss" scoped>

div.products {
    margin-top: 32px;
}
span.tag {
    margin-left: 8px;
}


</style>
